export const TOAST_CHANNELS = {
    notifications: 'notifications',
    toasts: 'toasts',
} as const
